import { render, staticRenderFns } from "./PainelCompraDiretaVisualizacao.vue?vue&type=template&id=07eb62d2"
import script from "./PainelCompraDiretaVisualizacao.vue?vue&type=script&lang=js"
export * from "./PainelCompraDiretaVisualizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports